import { useQuery } from "@tanstack/react-query";
import { getCategories, getSubCategories } from "../../api/category.api";

export const useCategories = (options = {}) => {
    return useQuery({
        queryKey: ["categories"],
        queryFn: getCategories,
        staleTime: 1000 * 60 * 30, // 30 minutes
        gcTime: 1000 * 60 * 60, // 1 hour
        ...options
    });
};

export const useSubCategories = (catgId) => {
    return useQuery({
        queryKey: ["subcategories", catgId],
        queryFn: () => getSubCategories(catgId),
        enabled: !!catgId, // Only run the query if catgId is truthy
        staleTime: 1000 * 60 * 30, // 30 minutes
        gcTime: 1000 * 60 * 60, // 1 hour
    });
};
